import { ThemeKey } from "@smartsheet/design-tokens";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";

export type InputFieldHeightType = 32 | 40;
export interface InputFieldBaseProps {
    /**
     * Height of the input field component.  Other props may cause the component to render larger (like
     *  minHeight or TextArea rows).
     *
     * Defaults to 32 for Ursa, 40 for Lodestar. */
    inputFieldHeight?: InputFieldHeightType;
}

export const getInputFieldHeightValue = (
    themeMode: ThemeKey | RequiredThemeKeys,
    inputFieldHeight?: InputFieldHeightType
): InputFieldHeightType => {
    if (inputFieldHeight) return inputFieldHeight;
    if (themeMode === "lodestar-light") return 40;
    return 32;
};
